<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'pageIndex',
  props: {
  }
  
}
</script>